import ApiBase from './ApiBase'
import UserApi from './UserApi'

const ENDPOINT = process.env.API_ENDPOINT
const CACHE_EXPIRED_MINUTE = 30

class TwApi extends ApiBase {
  /**
   * Call Twitter API to get favs. This method will not check the cache.
   * @param {Number} count favs to get
   * @return {Promise}
   */
  _callListApi (api, token, secret, count) {
    return fetch(`${ENDPOINT}/${api}?count=${count}`, {
      headers: {
        'X-TwToken': token,
        'X-TwSecret': secret
      },
      mode: 'cors'
    }).then(response => {
      return response.json()
    })
  }

  _getTweetList (api, token, secret, totalCount) {
    if (api !== 'favs' && api !== 'myimgs') {
      return Promise.reject(new Error('invalid api name'))
    }
    if (!token || !secret) {
      return Promise.reject(new Error('no valid credencial is provided'))
    }
    const cached = this.lscache.get(`${api}/${token}`)
    if (cached) {
      return Promise.resolve(cached)
    }
    return this._callListApi(api, token, secret, totalCount)
      .then(json => {
        console.log('api resp:', json)
        this.lscache.set(`${api}/${token}`, json, CACHE_EXPIRED_MINUTE)
        this._cacheTweets(json.tweets)
        return json
      })
  }

  favs (token, secret, onPartiallyAvailable) {
    return this._getTweetList('favs', token, secret, 200)
  }

  my (token, secret, onPartiallyAvailable) {
    return this._getTweetList('myimgs', token, secret, 200)
  }

  status (id) {
    const token = UserApi.twToken
    const secret = UserApi.twSecret
    if (!token || !secret) {
      return Promise.reject(new Error('no valid credencial is provided'))
    }
    const cached = this.lscache.get(`status/${id}`)
    if (cached) {
      return Promise.resolve(cached)
    }
    return fetch(`${ENDPOINT}/tweet?statusid=${id}`, {
      headers: {
        'X-TwToken': token,
        'X-TwSecret': secret
      },
      mode: 'cors'
    }).then(response => {
      return response.json()
    }).then(json => {
      this._cacheTweets([json])
      return json
    }).catch((err) => {
      console.warn('failed to get tweet', err, id)
    })
  }

  _cacheTweets (tws) {
    tws.forEach(tw => {
      this.lscache.set(`status/${tw.id_str}`, tw, 60 * 24 * 30)
    })
  }
}

export default new TwApi()



// WEBPACK FOOTER //
// ./src/api/TwApi.js